
export function replaceChar(str,index,chr) {
    if(str && index > str.length-1) return str;
    return str && str.substring(0,index) + chr + str && str.substring(index+1);
}